export const SECURITY_TYPE = { 1: 'equity', 2: 'debt', 3: 'derivative' };
